// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

// Resources whose records only owner and admin may delete (mirrors the RLS
// delete policies).
const ADMIN_DELETE_ONLY_RESOURCES = [
  "deals",
  "contacts",
  "companies",
  "contact_notes",
  "deal_notes",
  "tasks",
];

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin" || role === "owner") {
    return true;
  }

  if (
    params.action === "delete" &&
    ADMIN_DELETE_ONLY_RESOURCES.includes(params.resource)
  ) {
    return false;
  }

  // Non admins can't access the sales resource
  if (params.resource === "sales") {
    return false;
  }

  // Non admins can't access the configuration resource
  if (params.resource === "configuration") {
    return false;
  }

  // Everyone signed in reads public holidays (the 48-hour clock needs them);
  // only admins write them (mirrors the RLS policies).
  if (
    params.resource === "public_holidays" &&
    !["list", "show", "read"].includes(params.action)
  ) {
    return false;
  }

  return true;
};
